import React, { useEffect, useMemo, useState } from 'react';
import { ProfileData, Token } from '../../model/Model';
import { useHistory, useParams } from 'react-router';
import { useCheckinState } from '../../state/state';
import { SummaryBlock } from '../common/SummaryBlock';
import { ActionButton } from '../common/ActionButton';
import { Spacer } from '../common/Spacer';
import { VisitorForm } from '../common/VisitorForm';
import { CheckboxInline } from '../common/CheckboxInline';
import { Reporting } from '../common/Reporting';
import { FetchSiteState } from '../common/FetchSiteState';
import { SiteStyle } from '../common/SiteStyle';
import { WhenReady } from '../common/WhenReady';
import { SiteHeader } from '../common/SiteHeader';
import { Logo } from '../common/Logo';
import { SearchVisitorState } from '../../state/checkin-actions';


export const SearchVisitor = () => {
    const history = useHistory();
    const { token } = useParams<Token>();

    const { loading, search } = useCheckinState();

    const [visitorState, setVisitorState] = useState(SearchVisitorState.SEARCH);
    const [buttonText, setButtonText] = useState('Next');

    useEffect(() => {
        if (loading) {
            setButtonText('Searching...')
        } else {
            setButtonText('Next');
        }
    }, [loading]);

    const onSearch = (profile: ProfileData) => {
        search(token, profile, true, visitorState => {
            setVisitorState(visitorState);
            if (visitorState === SearchVisitorState.FOUND) {
                history.replace(`/checked/${token}`);
            }
        });
    }

    const onClose = () => {
        history.replace(`/welcome/${token}`);
    };

    const onCheckinNow = () => {
        history.replace(`/checkin/${token}?l=1`);
    };

    const body = useMemo(() => {
        switch (visitorState) {
            case SearchVisitorState.SEARCH:
                return (
                    <VisitorForm onSubmit={onSearch}
                                 readonly={false}>
                        <ActionButton text={buttonText} disabled={loading} submit />
                        <CheckboxInline name="rememberMe" label='Remember contact details for next time' />
                    </VisitorForm>
                );
            case SearchVisitorState.NO_ACTIVE_LOGIN:
                return (
                    <>
                        <Spacer height='2em' />
                        <SummaryBlock display className='body-text text-center'>
                            No active check in exists for this site.
                        </SummaryBlock>
                        <ActionButton text='Check In Now' onClick={onCheckinNow} />
                        <ActionButton text='Close' onClick={onClose} />
                    </>);
            case SearchVisitorState.NO_WORKER_FOUND:
                return (
                    <>
                        <Spacer height='2em' />
                        <SummaryBlock display className='body-text text-center'>
                            No check in record exists for this site.
                        </SummaryBlock>
                        <ActionButton text='Close' onClick={onClose} />
                    </>);
            default:
                return null;
        }
    }, [visitorState, buttonText, loading]);

    return (
        <>
            <Reporting />
            <FetchSiteState />
            <SiteStyle />
            <WhenReady>
                <Spacer height='2em' />
                <SiteHeader/>
                <Spacer height='2em' />
                {body}
                <Spacer height='6em' />
                <Logo />
            </WhenReady>
        </>
    )
}
